module.exports = __webpack_public_path__ + "img/image42.b785fc46.png";